import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

// Components
import LoadingArea from '@molecules/LoadingArea';
import { BodyLarge, DividerLightGreyStyled, H4, BodyMedium } from '@styled';

// Functionality
import { generateSavedSearchTitle } from '../../../helpers/savedSearches.helpers';
import useMemberFull from '@hooks/useMemberFull';

const MemberProfileCurrentInterests = ({ graphID }) => {
    const { data } = useMemberFull(graphID);

    const [productsAndServices, setProductsAndServices] = useState([]);
    const [networking, setNetworking] = useState([]);

    useEffect(() => {
        if (!data) return;

        setProductsAndServices(
            data.savedSearches
                .filter(search => ['PRODUCTS'].includes(search.primaryInterest))
                .map(search => generateSavedSearchTitle(search))
        );
    }, [data]);

    useEffect(() => {
        if (!data) return;

        setNetworking(
            data.savedSearches
                .filter(search => search.primaryInterest === 'CONNECTIONS')
                .map(search => generateSavedSearchTitle(search))
        );
    }, [data]);

    if (!data) return <LoadingArea />;

    if (data.savedSearches.length === 0) {
        return <BodyLarge>{data.firstName} has not defined their interests.</BodyLarge>;
    }

    return (
        <div className="fade-in-fast">
            <BodyLarge style={{ marginBottom: '2rem' }}>{data.firstName}'s current interests</BodyLarge>
            <DividerLightGreyStyled />

            {productsAndServices.length > 0 && (
                <div>
                    <H4 style={{ marginBottom: '1rem', marginTop: '2rem' }}>Products and Services</H4>
                    <ul style={{ paddingLeft: '1.6rem', marginBottom: '2rem' }}>
                        {productsAndServices.map((interest, i) => (
                            <li key={`saved-search-interest-${data.id}-${i}`} style={{ marginBottom: '5px' }}>
                                <BodyMedium>{interest}</BodyMedium>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {productsAndServices.length > 0 && networking.length > 0 && <DividerLightGreyStyled />}

            {networking.length > 0 && (
                <div>
                    <H4 style={{ marginBottom: '1rem', marginTop: '2rem' }}>Networking</H4>
                    <ul style={{ paddingLeft: '1.6rem' }}>
                        {networking.map((region, i) => (
                            <li key={`saved-search-region-${data.id}-${i}`} style={{ marginBottom: '5px' }}>
                                <BodyMedium>{region}</BodyMedium>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

MemberProfileCurrentInterests.propTypes = {
    graphID: PropTypes.string,
};

export default MemberProfileCurrentInterests;
